import { render, staticRenderFns } from "./TotalHealth.vue?vue&type=template&id=46932c1e&scoped=true"
import script from "./TotalHealth.vue?vue&type=script&lang=js"
export * from "./TotalHealth.vue?vue&type=script&lang=js"
import style0 from "./TotalHealth.vue?vue&type=style&index=0&id=46932c1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46932c1e",
  null
  
)

export default component.exports